var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "mb-2 d-flex item",
      class: { current: _vm.isCurrent, trashed: _vm.isTrashed },
      style: _vm.styles,
      on: { click: _vm.onSelect },
    },
    [
      _c(
        "div",
        { staticClass: "d-flex align-items-center flex-shrink-0 pr-2" },
        [
          !_vm.isEdit
            ? _c("i", {
                staticClass: "far fa-lg",
                class: {
                  "fa-check-square": _vm.isSelected,
                  "fa-square": !_vm.isSelected || _vm.isTrashed,
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.onToggle.apply(null, arguments)
                  },
                },
              })
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "flex-grow-1" }, [
        _c("div", [
          _c("span", { staticClass: "item-title" }, [
            _c(
              "span",
              {
                staticClass: "contact",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _vm.inDoNotContact
                  ? _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "light",
                          content: "Do Not Contact",
                          placement: "left",
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "text-danger cursor-default" },
                          [_c("i", { staticClass: "fas fa-user-slash" })]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.filemakerId
                  ? _c("span", { staticClass: "filemaker-id" }, [
                      _vm._v(_vm._s(_vm.filemakerId) + " "),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "contact-full-name" }, [
                  _vm._v(_vm._s(_vm._f("uppercase")(_vm.contactFullName))),
                ]),
                _vm._v(" "),
                _vm.hasContactPhoneNumber
                  ? _c("span", { staticClass: "contact-phone-number" }, [
                      _vm._v("(" + _vm._s(_vm.contactPhoneNumber) + ")"),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("span", { staticClass: "item-title" }, [
            _c(
              "span",
              {
                staticClass: "contact",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _vm.outgoingNumberTitle
                  ? _c("span", [
                      _vm._v(
                        _vm._s(_vm._f("uppercase")(_vm.outgoingNumberTitle))
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "contact-full-name" }, [
                  _vm._v(
                    "(" +
                      _vm._s(
                        _vm._f("uppercase")(_vm.outgoingNumberPhoneNumber)
                      ) +
                      ")"
                  ),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-shrink-0 align-items-center" }, [
        _c("div", [
          _c("div", [
            _c(
              "div",
              { staticClass: "d-flex justify-content-end" },
              [
                _c(
                  "el-tooltip",
                  { attrs: { content: "Make a call", placement: "top" } },
                  [
                    _vm.canMakeCall
                      ? _c("outbound-call", {
                          staticClass: "btn btn-sm btn-success mr-1",
                          attrs: {
                            conversation: _vm.conversation,
                            disabled: !_vm.hasContactPhoneNumber,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  { attrs: { content: "Move to group", placement: "top" } },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-purple mr-1",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.onMove.apply(null, arguments)
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-arrow-right" })]
                    ),
                  ]
                ),
                _vm._v(" "),
                !_vm.isEdit
                  ? _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: "Filter send lists",
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-purple mr-1",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.onFilter.apply(null, arguments)
                              },
                            },
                          },
                          [_c("i", { staticClass: "fas fa-filter" })]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  { attrs: { content: "Private chat", placement: "top" } },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-purple mr-1",
                        attrs: {
                          disabled:
                            !_vm.canSendMessage && !_vm.canSendApprovedMessage,
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.onSend.apply(null, arguments)
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-paper-plane" })]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  { attrs: { content: "Edit", placement: "top" } },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-purple mr-1",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.onEdit.apply(null, arguments)
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-edit" })]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  { attrs: { content: "Delete", placement: "top" } },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-danger",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.onDelete.apply(null, arguments)
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-times fa-wider" })]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.expiresIn
            ? _c("div", { staticClass: "d-flex justify-content-end pt-1" }, [
                _c(
                  "span",
                  {
                    staticClass: "badge",
                    class: {
                      "badge-info": _vm.expiresIn.isFuture,
                      "badge-warning": !_vm.expiresIn.isFuture,
                    },
                  },
                  [
                    _vm._v(
                      "\n                      " +
                        _vm._s(_vm.expiresIn.text) +
                        "\n                  "
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.isTrashed
        ? _c(
            "div",
            { staticClass: "trashed-controls" },
            [
              _c(
                "el-tooltip",
                {
                  attrs: { content: "Restore conversation", placement: "top" },
                },
                [
                  _c("i", {
                    staticClass: "fas fa-redo",
                    on: { click: _vm.onRestore },
                  }),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }